
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/tilgungsrechner", function() {
      var page = require("private-next-pages/tilgungsrechner.tsx")
      if(module.hot) {
        module.hot.accept("private-next-pages/tilgungsrechner.tsx", function() {
          if(!next.router.components["/tilgungsrechner"]) return
          var updatedPage = require("private-next-pages/tilgungsrechner.tsx")
          next.router.update("/tilgungsrechner", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  